import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { JsonViewerDialogComponent } from './json-viewer-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class JsonViewerService {
  constructor(private dialog: MatDialog) {}

  openJsonViewer(jsonData: any): void {
    this.dialog.open(JsonViewerDialogComponent, {
      data: jsonData,
      width: '80%',
      maxWidth: '1200px'
    });
  }
}
